var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var template = "\n  <div class=\"input-group input-group--text\" :class=\"{ 'input-group--required': required, 'input-group--invalid': isInvalid }\">\n    <label :for=\"`input-text${_uid}`\" class=\"input-group__label\">\n      {{ label }}\n      <slot></slot>\n    </label>\n    <div class=\"input-group__input-container\" :class=\"containerClass\">\n      <input :id=\"`input-text${_uid}`\"\n             type=\"date\"\n             v-model=\"valueAsInput\"\n             v-validate=\"validation\"\n             :name=\"computedName\"\n             class=\"input-group__input input-group__input--date\"\n             :class=\"inputClass\"\n             :min=\"min\"\n             :max=\"max\"\n             v-bind=\"vBind\"\n             v-on=\"vOn\"\n             @focus=\"focusEvent\"\n             @blur=\"blurEvent\"\n      />\n\n      <a class=\"input-group__clear\" v-show=\"cleanable && valueAsInput\" @click=\"emitEmpty\"></a>\n    </div>\n    <transition name=\"slide\">\n      <div class=\"input-group__error-message\" v-if=\"isInvalid\">{{ errors.first(label) }}</div>\n    </transition>\n  </div>\n";
import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import moment from 'moment';
var InputDate = /** @class */ (function (_super) {
    __extends(InputDate, _super);
    function InputDate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputDate.prototype.inputFromDt = function (dt) {
        return dt ? moment(dt).format('YYYY-MM-DD') : null; // html input format
    };
    InputDate.prototype.dtFromInput = function (dt) {
        if (!dt) {
            return null;
        }
        var dtMoment = moment(dt);
        if (dtMoment.year() < 1000 || dtMoment.year() > 9999) {
            return null;
        }
        return dtMoment.format();
    };
    Object.defineProperty(InputDate.prototype, "valueAsInput", {
        get: function () {
            return this.value ? this.inputFromDt(this.value) : null;
        },
        set: function (val) {
            if (!val) {
                return;
            }
            var dt = this.dtFromInput(val);
            if (dt) {
                this.$emit('input', dt);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputDate.prototype, "isInvalid", {
        get: function () {
            // @ts-ignore
            return this.errors.first(this.label);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputDate.prototype, "computedName", {
        get: function () {
            return this.name || this.label || '-';
        },
        enumerable: true,
        configurable: true
    });
    InputDate.prototype.created = function () {
        if (this.validator) {
            this.$validator = this.validator;
        }
    };
    Object.defineProperty(InputDate.prototype, "listeners", {
        get: function () {
            var listeners = __assign({}, this.$listeners);
            delete listeners.input;
            return listeners;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputDate.prototype, "vBind", {
        get: function () {
            return __assign({}, this.$attrs);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputDate.prototype, "vOn", {
        get: function () {
            return __assign({}, this.listeners);
        },
        enumerable: true,
        configurable: true
    });
    InputDate.prototype.emitEmpty = function () {
        this.$emit('input', null);
    };
    InputDate.prototype.focusEvent = function () {
        this.$emit('focus');
    };
    InputDate.prototype.blurEvent = function () {
        this.$emit('blur');
    };
    __decorate([
        Prop({ type: String, default: null }),
        __metadata("design:type", Object)
    ], InputDate.prototype, "value", void 0);
    __decorate([
        Prop({ type: String, default: null }),
        __metadata("design:type", Object)
    ], InputDate.prototype, "label", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputDate.prototype, "name", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], InputDate.prototype, "required", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], InputDate.prototype, "inputClass", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], InputDate.prototype, "containerClass", void 0);
    __decorate([
        Prop({ type: String, default: null }),
        __metadata("design:type", String)
    ], InputDate.prototype, "min", void 0);
    __decorate([
        Prop({ type: String, default: null }),
        __metadata("design:type", String)
    ], InputDate.prototype, "max", void 0);
    __decorate([
        Prop({ type: Boolean, default: true }),
        __metadata("design:type", Boolean)
    ], InputDate.prototype, "cleanable", void 0);
    __decorate([
        Prop({ default: null }),
        __metadata("design:type", Object)
    ], InputDate.prototype, "validation", void 0);
    __decorate([
        Inject({ from: 'validator', default: null }),
        __metadata("design:type", Object)
    ], InputDate.prototype, "validator", void 0);
    InputDate = __decorate([
        Component({ template: template })
    ], InputDate);
    return InputDate;
}(Vue));
export { InputDate };
//# sourceMappingURL=InputDate.js.map